import type { FC } from 'react';

export const InfinityIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.0925 8C6.46 7.205 5.8275 6.5 5.25 6.5C4.2325 6.5 3.875 7.31 3.875 8C3.875 8.69 4.2325 9.5 5.25 9.5C5.8275 9.5 6.46 8.795 7.0925 8Z"
        fill="#6A73B5"
      />
      <path
        d="M12.125 8C12.125 7.31 11.7675 6.5 10.75 6.5C10.1587 6.5 9.54 7.205 8.9075 8C9.52625 8.795 10.1587 9.5 10.75 9.5C11.7675 9.5 12.125 8.69 12.125 8Z"
        fill="#6A73B5"
      />
      <path
        clipRule="evenodd"
        d="M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5ZM2.5 8C2.5 6.515 3.44875 5 5.25 5C6.33625 5 7.2025 5.84 8 6.83C8.7975 5.84 9.63625 5 10.75 5C12.5512 5 13.5 6.515 13.5 8C13.5 9.485 12.5512 11 10.75 11C9.63625 11 8.7975 10.16 8 9.17C7.2025 10.16 6.33625 11 5.25 11C3.44875 11 2.5 9.485 2.5 8Z"
        fill="#6A73B5"
        fillRule="evenodd"
      />
    </svg>
  );
};
